module.exports = __webpack_public_path__ + "images/banners/item_top/item_top_banner_balloon_2e8b36e803850558688c651039318494.png";